import EditorNestedList, { NestedListData } from "@editorjs/nested-list";

/**
 * Custom subclass of the nested list block tool.
 */
export class NestedList extends EditorNestedList {
    /**
     * Checks if there is any contents and if not indicate the the block should
     * not be included in the saved data.
     * 
     * @param savedData The data generated by the save method.
     * @returns true if the block data should be included; false otherwise.
     */
    public validate(savedData: NestedListData) {
        return savedData.items.length > 0 && savedData.items[0].content !== "";
    }
}
